import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as Yup from 'yup';
// import { getbase64 } from '@/utils/base64Converter';
import { useFormik } from 'formik';
import { getbase64 } from '../../../utils/base64Converter';
import { InfinitySpin } from 'react-loader-spinner';
import { updateBrandImageDetails } from '../../../redux/admin/brand/brand_slices';
import {
  EditBrandDetail,
  UploadBrandImage,
} from '../../../redux/admin/brand/brand_services_sync';

const baseSchema = Yup.object({
  name: Yup.string().required(),
  slug: Yup.string(),
  description: Yup.string(),
});

const Edit_Brand = () => {
  const dispatch = useDispatch();

  const [image, setImage] = useState();

  const { brandEditLoader, brandImageDetails, bndEditLoader, brandDetails } =
    useSelector((state) => state.brand);

  const handleSubmited = async (value, { resetForm }) => {
    // e.preventDefault();

    if (bndEditLoader) return;

    const payload = {
      ...value,
      brand_image: brandImageDetails?.secure_url,
      brand_image_id: brandImageDetails?.public_id,
    };

    await dispatch(EditBrandDetail({ ...brandDetails, ...payload }));

    resetForm();

    // router.push('/admin_dashboard/users');
  };

  const {
    values,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    setFieldValue,
  } = useFormik({
    initialValues: {
      name: '',
      slug: '',
      description: '',
    },
    validationSchema: baseSchema,
    onSubmit: handleSubmited,
  });

  const handleBrandImage = (e) => {
    if (brandEditLoader) return;

    const image = e.target.files[0];

    if (image) {
      let promise = getbase64(image);
      promise
        .then((data) => {
          dispatch(UploadBrandImage({ file: data }));
          return data;
        })
        .then((res) => {
          setImage(image?.name);
        });
    }
  };

  useEffect(() => {
    setFieldValue('name', brandDetails?.name);

    setFieldValue('slug', brandDetails?.slug);

    setFieldValue('description', brandDetails?.description);

    setImage(brandDetails?.brand_image);

    dispatch(
      updateBrandImageDetails({
        secure_url: brandDetails?.brand_image,
        public_id: brandDetails?.brand_image_id,
      })
    );
  }, [brandDetails]);

  console.log(brandDetails, brandImageDetails, 'brandImageDetails');

  return (
    <>
      <div class="row">
        <div class="col-xl-3 col-lg-4">
          <div class="card">
            <div class="card-body">
              <div class="bg-light text-center rounded bg-light">
                {brandImageDetails?.secure_url && (
                  <img
                    src={brandImageDetails?.secure_url}
                    alt=""
                    class="avatar-xxl"
                  />
                )}
              </div>
              <div class="mt-3">
                <h4>{image ? image : <>Brand pics</>}</h4>
                {/* <div class="row">
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">Created By :</p>
                        <h5 class="mb-0">Seller</h5>
                      </div>
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">Stock :</p>
                        <h5 class="mb-0">46233</h5>
                      </div>
                      <div class="col-lg-4 col-4">
                        <p class="mb-1 mt-2">ID :</p>
                        <h5 class="mb-0">FS16276</h5>
                      </div>
                    </div> */}
              </div>
            </div>
            <div class="card-footer border-top">
              <div class="row g-2">
                {/* <div class="col-lg-6">
                      <a href="#!" class="btn btn-outline-secondary w-100">
                        Create Brand
                      </a>
                    </div> */}
                <div class="col-lg-6">
                  <a href="#!" class="btn btn-primary w-100">
                    Cancel
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-xl-9 col-lg-8 ">
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">Add Thumbnail Photo</h4>
            </div>
            <div class="card-body">
              <form
                action="https://techzaa.in/"
                method="post"
                class="dropzone"
                id="myAwesomeDropzone"
                data-plugin="dropzone"
                data-previews-container="#file-previews"
                data-upload-preview-template="#uploadPreviewTemplate"
                style={{ position: 'relative' }}
              >
                <div class="fallback">
                  <input
                    name="file"
                    type="file"
                    multiple
                    onChange={handleBrandImage}
                    style={{
                      border: '1px solid red',
                      position: 'absolute',
                      width: '98%',
                      height: '90%',
                      opacity: 0,
                    }}
                  />
                </div>
                <div class="dz-message needsclick">
                  <i class="bx bx-cloud-upload fs-48 text-primary"></i>
                  <h3 class="mt-4">
                    Drop your images here, or{' '}
                    <span class="text-primary">click to browse</span>
                  </h3>
                  <span class="text-muted fs-13">
                    {image ? (
                      `${image}`
                    ) : (
                      <>
                        1600 x 1200 (4:3) recommended. PNG, JPG and GIF files
                        are allowed
                      </>
                    )}
                  </span>
                </div>
              </form>
            </div>

            {brandEditLoader && (
              <div class="form-group col-sm-9">
                <InfinitySpin width="100" color="#FE6B30" />
              </div>
            )}
          </div>
          <div class="card">
            <div class="card-header">
              <h4 class="card-title">General Information</h4>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="category-title" class="form-label">
                        Brand Name
                      </label>
                      <input
                        type="text"
                        id="category-title"
                        class="form-control"
                        placeholder="Enter Name"
                        value={values.name || ''}
                        onChange={handleChange}
                        name="name"
                        style={{
                          border: errors.name && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                <div class="col-lg-6">
                  <form>
                    <div class="mb-3">
                      <label for="product-id" class="form-label">
                        Slug
                      </label>
                      <input
                        type="text"
                        id="slug"
                        class="form-control"
                        placeholder="Brand Slug"
                        value={values.slug || ''}
                        onChange={handleChange}
                        name="slug"
                        style={{
                          border: errors.slug && '1px solid red',
                        }}
                      />
                    </div>
                  </form>
                </div>

                {/* <div class="col-lg-6">
                      <form>
                        <label for="crater" class="form-label">
                          Created By
                        </label>
                        <select
                          class="form-control"
                          id="crater"
                          data-choices
                          data-choices-groups
                          data-placeholder="Select Crater"
                        >
                          <option value="">Select Crater</option>
                          <option value="Seller">Seller</option>
                          <option value="Admin">Admin</option>
                          <option value="Other">Other</option>
                        </select>
                      </form>
                    </div>
                    <div class="col-lg-6">
                      <form>
                        <div class="mb-3">
                          <label for="product-stock" class="form-label">
                            Stock
                          </label>
                          <input
                            type="number"
                            id="product-stock"
                            class="form-control"
                            placeholder="Quantity"
                          />
                        </div>
                      </form>
                    </div>
                     */}
                <div class="col-lg-12">
                  <div class="mb-0">
                    <label for="description" class="form-label">
                      Description
                    </label>
                    <textarea
                      class="form-control bg-light-subtle"
                      id="description"
                      rows="7"
                      placeholder="Type description"
                      value={values.description || ''}
                      onChange={handleChange}
                      name="description"
                      style={{
                        border: errors.description && '1px solid red',
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div class="card">
                <div class="card-header">
                  <h4 class="card-title">Meta Options</h4>
                </div>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <form>
                        <div class="mb-3">
                          <label for="meta-title" class="form-label">
                            Meta Title
                          </label>
                          <input
                            type="text"
                            id="meta-title"
                            class="form-control"
                            placeholder="Enter Title"
                          />
                        </div>
                      </form>
                    </div>
                    <div class="col-lg-6">
                      <form>
                        <div class="mb-3">
                          <label for="meta-tag" class="form-label">
                            Meta Tag Keyword
                          </label>
                          <input
                            type="text"
                            id="meta-tag"
                            class="form-control"
                            placeholder="Enter word"
                          />
                        </div>
                      </form>
                    </div>
                    <div class="col-lg-12">
                      <div class="mb-0">
                        <label for="description" class="form-label">
                          Description
                        </label>
                        <textarea
                          class="form-control bg-light-subtle"
                          id="description"
                          rows="4"
                          placeholder="Type description"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
          <div class="p-3 bg-light mb-3 rounded">
            <div class="row justify-content-end g-2">
              {/* <div class="col-lg-2">
                <a href="#!" class="btn btn-outline-secondary w-100">
                  Save Change
                </a>
              </div> */}
              <div class="col-lg-2">
                <a class="btn btn-primary w-100" onClick={handleSubmit}>
                  {bndEditLoader ? (
                    <div class="form-group col-sm-9">
                      <InfinitySpin width="100" color="#FE6B30" />
                    </div>
                  ) : (
                    <>Update Brand</>
                  )}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Edit_Brand;
